"use client"

import type React from "react"

export let Providers = ({ children }: { children: React.ReactNode }) => children
